<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="所属端" prop="type" >
<!--        <a-radio-group v-model="form.type">-->
<!--          <a-radio-button :value="1">患者端</a-radio-button>-->
<!--          <a-radio-button :value="2">医师端</a-radio-button>-->
<!--        </a-radio-group>-->
        <a-checkbox-group v-model="type">
          <a-checkbox :value="'1'">患者端</a-checkbox>
          <a-checkbox :value="'2'">医师端</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content" >
        <a-textarea :row="3" v-model="form.content" placeholder="请输入内容" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSurvey, addSurvey, updateSurvey } from '@/api/biz/survey'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      type: [],
      // 表单参数
      form: {
        id: null,

        type: null,

        title: null,

        content: null,

        isEnable: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [
          { 
            validator: (rule, value, callback) => {
              if (!this.type || this.type.length === 0) {
                callback(new Error('不能为空'))
              } else {
                callback()
              }
            }, 
            trigger: 'change' 
          }
        ],
        title: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        title: null,
        content: null,
        isEnable: null,
        createTime: null,
        remark: null,
      }
      this.type = []
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSurvey({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        // 将type字符串转换为数组，如果为空则设为空数组
        this.type = this.form.type ? this.form.type.split(',') : []
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          // 将type数组转换为字符串
          this.form.type = this.type && this.type.length > 0 ? this.type.join(',') : ''
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSurvey(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSurvey(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
